import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDto } from 'src/app/domain/models/dto/user.dto';
import { Observable } from 'rxjs';
import { ResponseObjectModel } from 'src/app/domain/models/response-object.model';
import {
  IRegisterDataModel,
  RegisterDataModel,
} from 'src/app/domain/models/register-data.model';
import { CompanyResponsibleDto } from 'src/app/domain/models/dto/company-responsible.dto';
import { UpdateUserDto } from 'src/app/domain/models/dto/update-user.dto';
import { IndividualAccountDto } from 'src/app/domain/models/dto/individual-account.dto';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(private readonly http: HttpClient) {}

  public register(user: UserDto) {
    return this.http.post<UserDto>(
      `${environment.API_BASE_URL}/v1/users`,
      user
    );
  }

  public registerForm(user: any, tenant: string, affiliateId?: string) {
    let url = `${environment.API_BASE_URL}/v1/register?tenant=${tenant}`;

    if (affiliateId) {
      url += '&affiliateId=' + affiliateId;
    }

    return this.http.post<any>(url, user);
  }

  public registerFormPF(user: any, tenant: string, affiliateId?: string) {
    let url = `${environment.API_BASE_URL}/v1/register-pf?tenant=${tenant}`;

    if (affiliateId) {
      url += '?affiliateId=' + affiliateId;
    }
    return this.http.post<any>(url, user);
  }

  public uploadDocument(id: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<UserDto>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}/document-file`,
      formData
    );
  }

  public uploadResidentialFile(id: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<UserDto>(
      `${environment.API_BASE_URL}/v1/people/${id}/residential-file`,
      formData
    );
  }

  public uploadProcurationFile(id: number, file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.put<UserDto>(
      `${environment.API_BASE_URL}/v1/company-responsibles/${id}/document-file/procuracao`,
      formData
    );
  }

  public registerCompanyResponsible(companyResponsible: CompanyResponsibleDto) {
    return this.http.post<CompanyResponsibleDto>(
      `${environment.API_BASE_URL}/v1/users/company-responsibles`,
      companyResponsible
    );
  }

  public registerSeeaway(userId: string) {
    return this.http.post<CompanyResponsibleDto>(
      `${environment.API_BASE_URL}/v1/seeaway/${userId}`,
      {}
    );
  }

  public registerSeeawayPF(userId: string) {
    return this.http.post<IndividualAccountDto>(
      `${environment.API_BASE_URL}/v1/seeaway/pf/${userId}`,
      {}
    );
  }

  public update(user: UserDto) {
    return this.http.put<UserDto>(`${environment.API_BASE_URL}/v1/users`, user);
  }

  public putRegisterStep(code: string): Observable<ResponseObjectModel<any>> {
    return this.http.put<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/users/register-step/${code}/next`,
      {}
    );
  }

  public getRegisterStep(): Observable<ResponseObjectModel<any>> {
    return this.http.get<ResponseObjectModel<any>>(
      `${environment.API_BASE_URL}/v1/users/register-step`
    );
  }

  public updateUserInfo(user: UpdateUserDto) {
    return this.http.put<UpdateUserDto>(
      `${environment.API_BASE_URL}/v1/people/users`,
      user
    );
  }

  public getRegister(userCode: string) {
    return this.http.get(`${environment.API_BASE_URL}/v1/users/${userCode}`);
  }

  public emailOperatorCode(email: string) {
    return this.http.post<any>(
      `${environment.API_BASE_URL}/v1/account/forgot-operator-code/${email}`,
      email
    );
  }

  public emailResetPassword(email: string, isAdmin: boolean) {
    return this.http.post<any>(
      `${environment.API_BASE_URL}/v1/account/reset-password/init/${email}/${isAdmin}`,
      email
    );
  }

  public resetPassword(key: string, password: string) {
    return this.http.post<any>(
      `${environment.API_BASE_URL}/v1/account/reset-password/finish`,
      { key: key, newPassword: password }
    );
  }
}
